export default "__VITE_ASSET__DoJaxEFV__"